/**
 * Add to cart popup message
 */
// Settings to the carousel init
function getSliderSettings() {
  return {
    dots:           true,
    infinite:       false,
    speed:          300,
    slidesToShow:   4,
    slidesToScroll: 4,
    responsive:     [
      {
        breakpoint: 1310,
        settings:   {
          slidesToShow:   3,
          slidesToScroll: 3,
          infinite:       false,
          dots:           true
        }
      },
      {
        breakpoint: 768,
        settings:   {
          slidesToShow:   2,
          slidesToScroll: 2,
          infinite:       false
        }
      },
      {
        breakpoint: 480,
        settings:   {
          slidesToShow:   1,
          slidesToScroll: 1,
          infinite:       false
        }
      }
    ]
  }
}

// Check if the number of slides is enough to init the carousel
function carouselInit(elementSelector) {
  let carouselLength = $(elementSelector).children('.product-card-wrapper').length;
  let bodyWidth = $('body').width();
  if (bodyWidth > 900) {
    bodyWidth = 900;
  }
  return bodyWidth / carouselLength < 220;
}

// Fix the height of the elements inside the carousel
function fixCarouselHeight(elementSelector) {
  // Give the same height for all the elements inside the carousel
  let maxHeight = 0;
  let thisH = 0;
  $(elementSelector).find('.product-card')
    .each(function(){
      thisH = $(this).height();
      if (thisH > maxHeight) {
        maxHeight = thisH;
      }
    })
    .height(maxHeight);
}

// Append messages on body to avoid exhibition bugs
// and remove duplicate messages
function fixPopupContent () {
  let element_selector = $('.woocommerce-ajax-message');
  $('body').append(element_selector);
  element_selector.each(function () {
    $('[id="' + this.id + '"]:gt(0)').remove();
  });
}

$(window).on('load',function() {
  // Single product carousel init on modal show
  $('.modal').on('shown.bs.modal', function () {
    if (carouselInit('.single-cross-sell-products')) {
      $('.single-cross-sell-products')
        .slick(getSliderSettings());
      fixCarouselHeight('.single-cross-sell-products');
    }
  });
  fixPopupContent();
});

$(document.body)
  .on('click', 'a.ajax_add_to_cart', function () {
    let observer = new MutationObserver(function(mutations) {
      mutations.every(function(mutation) {
        let attributeValue = $(mutation.target).prop(mutation.attributeName);
        if(attributeValue.indexOf("added") >= 0) {
          let productId = $(mutation.target).attr('data-product_id');
          // Pop the message up
          $('#product_id_'+productId)
            .modal('show');
          // If the cross-sell section is empty
          let crossSellSelector = '.cross-sell-products[data-product_id="'+productId+'"]';
          let crossSellLength = $(crossSellSelector).children().length;
          if( crossSellLength === 0) {
            // Ajax load the content and run all the fixes
            $.ajax({
              url:    ajax_link,
              method: 'post',
              data:   {
                action:     'get_shop_results',
                nonce:      ajax_nonce,
                product_id: productId
              },
              beforeSend: function() {
                $(".ajax-preloader-img").show();
                $(".related-title").hide();
              }
            }).done(function (data) {
              $(crossSellSelector)
                .html(JSON.parse(data).products);
              $(".ajax-preloader-img").hide();
              $(".related-title").show();
              fixPopupContent ();
              if(carouselInit(crossSellSelector)) {
                $(crossSellSelector)
                  .css('display', 'block')
                  .slick(getSliderSettings());
                fixCarouselHeight(crossSellSelector);
              }
            });
          }
        }
      });
    });
    observer.observe($(this)[0], {
      attributes: true,
      attributeFilter: ['class']
    });
  });
